<template>
  <div class="analytics-page mb-2">
    <div class="chart-container">
      <div id="chart" >
        <apexchart :key="chartKey" type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    deliverySent: {
      type: Array,
      required: true,
    },   
  },
  watch: {
    deliverySent: {
      immediate: true,
      handler(newData) {
        this.loading = !this.loading
        this.updateChart(newData);
        setTimeout(() =>{
          this.loading = !this.loading
        }, )  
      },
    },
  },
 
  methods: {
    updateChart(data) {
      const counts = data.map(sMetric => parseInt(sMetric.count));  
      this.series[1].data = counts    
      this.chartKey ++; 
      this.fillXAxisWithDates(data);
    },
    fillXAxisWithDates(data) {
      const dates = [];
      if (data.length === 0) {
        for (let i = data.length+9; i >= 1; i--) {
          dates.push(moment().subtract(i, 'days').format('MMMM-DD'));
        }
        dates.push(moment().format('MMMM-DD')); // Add the current date
      } else {
        const months = data.map(sMetric => (sMetric.month));
        const monthNames = this.mapAbbrevsToMonths(months);
        const days = data.map(sMetric => parseInt(sMetric.day));
        for (let i = 0; i < data.length; i++) {
          dates[i] = monthNames[i] + '-' + days[i]
        }
      }
      this.chartOptions.xaxis.categories = dates;
    },
    mapAbbrevsToMonths(abbrevs) {
      const monthMap = {
        1 : 'Jan',
        2 : 'Feb',
        3 : 'Mar',
        4 : 'Apr',
        5 : 'May',
        6 : 'Jun',
        7 : 'Jul',
        8 : 'Aug',
        9 : 'Sep',
        10 : 'Oct',
        11 : 'Nov',
        12 : 'Dec'
      };

      return abbrevs.map(abbrev => monthMap[abbrev]);
    },
  },
  
  data: function() {
      return {
        chartKey: 0,
        series: [
          { name: 'Deliveries Received', data: [0] },
          { name: 'Deliveries Sent', data: [0] }
        ],
        chartOptions: {
            chart: {
              toolbar: {
              show: false, // Ensures the toolbar is visible
              tools: {
                download: false // Disables the download option
              }
            },
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent',]
            },
            xaxis: {
              categories: [],
            },
            // yaxis: {
            //   title: {
            //     // text: '$ (thousands)'
            //   }
            // },
          yaxis: {
            title: {
              text: "Quantity",
              style: {
                fontSize: '14px',
                fontWeight: 'bold',
              }
            },
            labels: {
              formatter: function (val) {
                return  val.toLocaleString(); // format with only commas
              }
            }
          },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return "" + val + ""
                  // return "# " + val + " thousands"
                }
              }
            },
            legend: {
              show: true,
              position: 'top',
              horizontalAlign: 'left'  ,// Set legend alignment to left
              fontSize: '15px'
              
            },
            colors: ['#09B78A','#D72638'] 
          },   
      }
    }, 
}
</script>

<style scoped>
.analytics-page {
  padding: 20px;
  width: 97%;
  border: 2px solid transparent;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 2px #00000014;
}
.chart-container {
  height: 400px;
}
</style>




